import { render, staticRenderFns } from "./StudentVideos.vue?vue&type=template&id=215ba27d&"
import script from "./StudentVideos.vue?vue&type=script&lang=js&"
export * from "./StudentVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports